import { bTh } from "../../../../../helpers/functions/report-table";
import "./dashboard-st-table.css";

export default function Server({ data, getReqPerSec }) {
  return (
    <div className="server-table">
      <h6 className="table-title pb-2">Server:</h6>

      <div className="report-table-container">
        <table>
          <thead>
          <tr>
            <th colSpan="4">Connections</th>
            <th colSpan="4">Requests</th>
            <th colSpan="3">Shared memory</th>
          </tr>
          <tr>
            <th>active</th>
            <th>reading</th>
            <th>writing</th>
            <th>waiting</th>
            <th>accepted</th>
            <th>handled</th>
            <th>Total</th>
            <th>Req/s</th>
            <th>maxSize</th>
            <th>usedSize</th>
            <th>usedNode</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{data?.connections?.active}</td>
            <td>{data?.connections?.reading}</td>
            <td>{data?.connections?.writing}</td>
            <td>{data?.connections?.waiting}</td>
            <td>{data?.connections?.accepted}</td>
            <td>{data?.connections?.handled}</td>
            <td>{data?.connections?.requests}</td>
            <td>{getReqPerSec("server-reqs", data?.connections?.requests)}</td>
            <td>{bTh(data?.sharedZones?.maxSize)}</td>
            <td>{bTh(data?.sharedZones?.usedSize)}</td>
            <td>{data?.sharedZones?.usedNode}</td>
          </tr>
          </tbody>
        </table>
      </div>

    </div>
  )
}
